import { LIVE_CAMPAIGN_STATUSES } from 'consts/campaignStatus';
import {
  DirectSalesCampaignDealLineResponse,
  DirectSalesTransientDealLineState,
  DirectSalesIntendedTargetState,
} from 'components/common/types/DirectSalesCampaign.types';

export const transformTargetStatusesToTransientDealLinesState = (
  dealLines: Pick<DirectSalesCampaignDealLineResponse, 'id' | 'targetState' | 'status'>[],
): DirectSalesTransientDealLineState => {
  const targetStatuses = dealLines
    .map(({ id, targetState, status }) => {
      if (LIVE_CAMPAIGN_STATUSES.includes(status)) {
        return {
          id,
          targetState: {
            intendedDealLineState: status,
            expires: null,
          },
        };
      }

      return {
        id,
        targetState,
      };
    })
    .filter((lineTargetStatus) => lineTargetStatus.targetState);

  return Object.fromEntries(
    targetStatuses.map(({ id, targetState }: { id: string; targetState: DirectSalesIntendedTargetState }) => [
      `${id}`,
      { status: targetState.intendedDealLineState, expires: targetState.expires },
    ]),
  );
};
